import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NoteService } from '../../shared/services/note.service';

@Component({
  selector: 'app-expertise-note',
  templateUrl: './expertise-note.component.html',
  styleUrls: ['./expertise-note.component.scss']
})
export class ExpertiseNoteComponent implements OnInit {

	@Input() note: any;
  	@Output() noteDeleted: EventEmitter<any> = new EventEmitter<any>();

  	constructor(private noteService: NoteService) { }

  	ngOnInit() {
  	}

  	deleteNote() {
  		this.noteService.delete(this.note.id).subscribe(n => {
  			console.log('delete', this.note);
  			this.noteDeleted.emit(this.note.id);
  		})
  	}

}
